var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssets01 = function SvgAssets01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "assets-01_svg2__a",
    x1: 35.96,
    x2: 161.33,
    y1: 154.59,
    y2: 44.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#assets-01_svg2__a",
    id: "assets-01_svg2__b",
    x1: 35.31,
    x2: 160.67,
    y1: 153.84,
    y2: 43.72
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m184.99 130.61-11.67-6.48V72.51l11.6-6.44c1.07-.6 1.73-1.73 1.73-2.93V46.87c0-1.2-.67-2.33-1.67-2.93l-13.33-7.4c-1.07-.53-2.27-.53-3.27 0l-13.33 7.4c-.32.18-.61.42-.85.69l-37.49-20.82V10.74c0-1.2-.67-2.33-1.73-2.93L101.67.4c-1.07-.53-2.27-.53-3.27 0L85.07 7.8c-1.07.6-1.73 1.73-1.73 2.93v13.1l-37.5 20.83c-.24-.28-.52-.53-.84-.72l-13.33-7.4c-1.07-.53-2.27-.53-3.27 0l-13.33 7.4c-1.07.6-1.73 1.73-1.73 2.93v16.27c0 1.2.67 2.33 1.73 2.93l11.6 6.44v51.66l-11.6 6.44c-1.07.6-1.73 1.73-1.73 2.93v16.27c0 1.2.67 2.33 1.73 2.93l13.33 7.4c.47.27 1.07.4 1.6.4s1.13-.13 1.6-.4l11.39-6.32 40.35 22.42v13.03c0 1.2.67 2.33 1.73 2.93l13.33 7.4c.47.27 1.07.4 1.6.4s1.13-.13 1.67-.4l13.33-7.4c1.07-.6 1.73-1.73 1.73-2.93v-13.13l40.22-22.35 11.45 6.35c.47.27 1.07.4 1.6.4s1.13-.13 1.6-.4l13.33-7.4c1.07-.6 1.73-1.73 1.73-2.93v-16.27c0-1.2-.67-2.33-1.67-2.93M160 48.8l10-5.53 10 5.53v12.4l-10 5.53-10-5.53zM90 12.67l10-5.53 10 5.53v12.47l-10 5.53-10-5.53zM20 61.2V48.8l10-5.53 10 5.53v12.4l-10 5.53zm20 86.66-10 5.54-10-5.53v-12.4L30 130l10 5.53zm70 39.47-10 5.53-10-5.53v-12.47l10-5.53 10 5.6zm46.64-57.6-14.91-9.39c-1.53-.93-3.6-.47-4.6 1.07-.93 1.53-.47 3.6 1.07 4.6l15.13 9.54v12.64l-38.8 21.56-11.2-6.22v-20.19c0-1.87-1.47-3.33-3.33-3.33s-3.33 1.47-3.33 3.33v20.23l-11.23 6.23-38.77-21.55v-12.92l14.8-9.33c1.6-1 2.07-3.07 1.07-4.6-1-1.6-3.07-2.07-4.6-1.07l-14.72 9.27-9.88-5.48V72.5l9.85-5.47 14.75 9.29c.6.33 1.2.53 1.8.53 1.13 0 2.2-.53 2.8-1.6.93-1.53.47-3.6-1.07-4.6l-14.8-9.33v-9.53L85.5 30.22l11.18 6.2c0 .07-.01.15-.01.22v13.33c0 1.87 1.47 3.33 3.33 3.33s3.33-1.47 3.33-3.33V36.45l11.24-6.24 38.77 21.53v9.47l-15.07 9.49c-1.6 1-2.07 3.07-1.07 4.6.6 1 1.67 1.53 2.8 1.53.6 0 1.2-.2 1.8-.47l14.93-9.41 9.93 5.51v51.66l-10.03 5.56v.05Zm23.36 5.8v12.33l-10 5.53-10-5.53v-12.4l10-5.47 10 5.53Z",
    style: {
      fill: "url(#assets-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41 76.4h-.02s-.02 0-.02-.02c-.22-.22-.48-.42-.76-.58l-30-16.67c-1.07-.53-2.27-.53-3.27 0l-30 16.67c-.52.28-.93.7-1.21 1.18a.3.3 0 0 0-.04.08c-.05.09-.1.19-.14.28 0 .03-.02.05-.03.08-.19.48-.28 1.01-.24 1.53v36.38c0 1.2.67 2.33 1.73 2.93l29.83 16.57c.17.1.35.19.53.27.03 0 .06.02.09.03.1.04.21.07.32.1.03 0 .05 0 .08.02.11.02.22.05.34.06q.21.03.42.03c.6 0 1.2-.13 1.73-.47.03-.02.05-.03.08-.05l29.79-16.55c1.07-.6 1.73-1.73 1.73-2.93V78.67c0-.89-.33-1.66-.93-2.25 0 0 0-.01-.01-.02m-35.74 49.93L73.34 113.4V84.33l23.33 12.93zm3.39-34.82L76.91 78.65 100 65.8l23.15 12.88zm26.61 21.89-23.27 12.87v-29l23.27-12.93z",
    style: {
      fill: "url(#assets-01_svg2__b)"
    }
  }));
};
export default SvgAssets01;